'use client';

import Image from 'next/image';

import { TransformedDapp } from '@/utils';
import Link from 'next/link';
import { DropdownButton } from '../DropdownButton';
import { ExternalLinkIcon } from '../icons';
import { ExternalLinkWarning } from '../ExternalLinkWarning';

export const DappHeader = ({
  dapp,
  handleClose,
}: {
  dapp: TransformedDapp | Record<string, any>;
  handleClose: () => void;
}) => {
  const exchangeCategories = ['Exchange', 'DEX'];
  const isExchange = dapp.category && exchangeCategories.includes(dapp.category);

  return (
    <div className="w-full flex items-center justify-between">
      <div className="flex items-center gap-2 w-full">
        {dapp?.logo ? (
          <div className="rounded border border-neutral-900 overflow-hidden">
            <Image src={dapp.logo} width={44} height={44} alt={`${dapp.name} logo`} />
          </div>
        ) : null}
        <div className="flex flex-col items-start">
          <span className="font-mono font-bold text-neutral-100 text-lg uppercase mt-[-5px]">{dapp?.name}</span>
          <span className="text-xs font-mono uppercase text-grey-600 max-w-[130px] text-center whitespace-nowrap truncate">
            {dapp?.category}
          </span>
        </div>
      </div>
      <div className="w-full flex items-center gap-4">
        <div className="flex flex-1 items-center gap-2">
          <Link
            rel="noopener noreferrer"
            target="_blank"
            href={dapp?.rewardsUrl || ''}
            className="h-[42px] w-[42px] flex justify-center border border-grey-700 bg-neutral-950 px-2 py-2 rounded-lg"
          >
            <Image src="/assets/icons/chain-icon.svg" width={20} height={20} alt={`chain link`} />
          </Link>
          <Link
            rel="noopener noreferrer"
            target="_blank"
            href={dapp?.twitterx || ''}
            className="h-[42px] w-[42px]  flex justify-center border border-grey-700 bg-neutral-950 px-2 py-2 rounded-lg"
          >
            <Image src="/assets/icons/x-icon.svg" width={20} height={20} alt={`x logo`} />
          </Link>
          <Link
            rel="noopener noreferrer"
            target="_blank"
            href={dapp?.discord || ''}
            className="h-[42px] w-[42px] flex justify-center border border-grey-700 bg-neutral-950 px-2 py-2 rounded-lg"
          >
            <Image src="/assets/icons/discord-icon.svg" width={20} height={20} alt={`discord logo`} />
          </Link>
          <ExternalLinkWarning className="min-w-fit" href={dapp.website || 'https://merkl.angle.money/?chain=34443'}>
            <DropdownButton className="w-full items-center flex gap-1 border border-yellow-500 text-yellow-500 px-4 py-2">
              {isExchange ? 'Deposit' : 'Go to Dapp'}
              <ExternalLinkIcon size={16} />
            </DropdownButton>
          </ExternalLinkWarning>
        </div>

        <div className="flex items-center w-6 h-6 hover:text-white" onClick={handleClose}>
          <Image src="/assets/icons/close-icon.svg" width={12} height={12} alt={`close icon`} />
        </div>
      </div>
    </div>
  );
};
